import { useNavigate } from "react-router-dom";

import { Card, CardContent, Typography } from "@mui/material";

import { ActionButton } from "components/ActionButton";

export function SysAdminConsole() {
  const navigate = useNavigate();

  return (
    <Card variant="outlined" sx={{ maxWidth: 750, mt: 2 }}>
      <CardContent>
        <Typography sx={{ mb: 1 }} variant="h4">
          SysAdmin
        </Typography>
        <ActionButton
          onClick={() => navigate("/supportconsole/batchsqlupdate")}
          dataTesting="batchSqlUpdateLink"
        >
          Batch SQL Update
        </ActionButton>
      </CardContent>
    </Card>
  );
}
